import {
    GET_OFFERINGTAB_FORMS, GET_SEARCH_COURSES, GET_BOOKLIST,
    GET_WAITINGLIST,
    GET_COURSEFEE,
    GET_ROOM_SCHEDULE_CONFLICTS_SUCCESS,
    RESET_ROOM_SCHEDULE_CONFLICTS,
    GET_ROOM_SCHEDULE_CONFLICTS,
    HIDE_ROOM_CONFLICTS_MODAL,
    GET_FACULTY_SCHEDULE_CONFLICTS_SUCCESS,
    GET_FACULTY_SCHEDULE_CONFLICTS,
    RESET_FACULTY_SCHEDULE_CONFLICTS,
    HIDE_FACULTY_CONFLICTS_MODAL
} from './types'

const initialState = {
    offeringTabFormValues: {
        "termCalendarID": 0,
        "courseName": "",
        "department": "",
        "courseID": "",
        "courseType": "",
        "section": "",
        "campusID": "-1",
        "page": 1,
        "pageSize": 10000,
        "facultyID": 0 //This is the temporary changes for bug-241590
    },
    courseTable: [],
    booklistTable: [],
    waitingListTable: [],
    courseFeesTable: [],
    roomScheduleConflictsData: [],
    isLoading: false,
    showRoomConflictsModal: false,
    showFacultyConflictsModal: false,
    roomConflictsChecked: false,
    facultyConflictsChecked: false,
    facultyConflictsData: []
};

const offeringMaintenanceReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_OFFERINGTAB_FORMS:
            return {
                ...state,
                offeringTabFormValues: { ...payload }
            };
        case GET_SEARCH_COURSES:
            return {
                ...state,
                courseTable: [...payload]
            };
        case GET_BOOKLIST:
            return {
                ...state,
                booklistTable: [...payload]
            };
        case GET_WAITINGLIST:
            return {
                ...state,
                waitingListTable: [...payload]
            };
        case GET_COURSEFEE:
            return {
                ...state,
                courseFeesTable: [...payload]
            };
        case GET_ROOM_SCHEDULE_CONFLICTS:
            return {
                ...state,
                isLoading: true
            };
        case GET_ROOM_SCHEDULE_CONFLICTS_SUCCESS:
            return {
                ...state,
                roomScheduleConflictsData: [...payload],
                isLoading: false,
                showRoomConflictsModal: payload.length > 0,
                roomConflictsChecked: true
            };
        case RESET_ROOM_SCHEDULE_CONFLICTS:
            return {
                ...state,
                roomScheduleConflictsData: [],
                roomConflictsChecked: false,
                showRoomConflictsModal: false
            };
        case HIDE_ROOM_CONFLICTS_MODAL:
            return {
                ...state,
                showRoomConflictsModal: false
            };
        case HIDE_FACULTY_CONFLICTS_MODAL:
            return {
                ...state,
                showFacultyConflictsModal: false
            };
        case GET_FACULTY_SCHEDULE_CONFLICTS:
            return {
                ...state,
                isLoading: true
            };
        case GET_FACULTY_SCHEDULE_CONFLICTS_SUCCESS:
            return {
                ...state,
                facultyConflictsData: [...payload],
                isLoading: false,
                showFacultyConflictsModal: payload.length > 0,
                facultyConflictsChecked: true
            };
        case RESET_FACULTY_SCHEDULE_CONFLICTS:
            return {
                ...state,
                facultyConflictsData: [],
                facultyConflictsChecked: false,
                showFacultyConflictsModal: false
            };
        default:
            return state;
    }
};

export default offeringMaintenanceReducer;